<h2 mat-dialog-title>Search Results</h2>
<mat-dialog-content class="search-results-table">
  <ng-container *ngIf="data.results?.length; else noResults">
    <table mat-table [dataSource]="data.results" class="mat-elevation-z2 full-width-table">
      <!-- ID Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>CAMS ID</th>
        <td mat-cell *matCellDef="let applicant">
          <span class="onView cursor-pointer" (click)="onViewApplicant(applicant)">
            {{ applicant.id }}
          </span>
        </td>
      </ng-container>

      <!-- Store Name Column -->
      <ng-container matColumnDef="storeName">
        <th mat-header-cell *matHeaderCellDef>Store Name</th>
        <td mat-cell *matCellDef="let applicant">
          <!-- {{ applicant.tenantName }} -->
          <span class="d-block">
            <ng-container [ngSwitch]="applicant.tenantName">
              <span *ngSwitchCase="'Crizac Limited'" class="badge rounded-pill text-bg-info">
                {{ applicant.tenantName }}
              </span>
              <span *ngSwitchCase="'GASPL'" class="badge rounded-pill text-bg-danger">
                {{ applicant.tenantName }}
              </span>
              <span *ngSwitchCase="'UCOL'" class="badge rounded-pill text-bg-danger-emphasis">
                {{ applicant.tenantName }}
              </span>
              <span *ngSwitchDefault class="badge rounded-pill bg-secondary no-border">
                {{ applicant.tenantName }}
              </span>
            </ng-container>
          </span>
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Course Details</th>
        <td mat-cell *matCellDef="let applicant">
          {{ applicant.coursesEnrolementRef?.universityName || "-" }}
          <span class="d-block text-cell-light-color">{{
            applicant.coursesEnrolementRef?.courseName || "-"
            }}</span>
          <span class="d-block text-cell-light-color">
            {{ applicant.coursesEnrolementRef?.courseOptions?.[0].options?.name || '-' }}
          </span>
        </td>
      </ng-container>

      <!-- studentDetails or Extra Info Column (optional) -->
      <ng-container matColumnDef="studentDetails">
        <th mat-header-cell *matHeaderCellDef>Student Details</th>
        <td mat-cell *matCellDef="let applicant">
          {{ applicant.studentPersonalDetailsRef?.firstName }}
          {{ applicant.studentPersonalDetailsRef?.lastName }}
          <span class="d-block"><span class="text-cell-light-color">Student Id:</span>
            {{ applicant.applicationFeesDetails?.studentId || "-" }}</span>
          <span class="d-block"><span class="text-cell-light-color">Passport:</span>
            {{ applicant.studentPersonalDetailsRef?.passPortNo || "-" }}</span>
        </td>
      </ng-container>


      <!-- Agent Details or Extra Info Column (optional) -->
      <ng-container matColumnDef="agentDetails">
        <th mat-header-cell *matHeaderCellDef>Agent Details</th>
        <td mat-cell *matCellDef="let applicant">
          <span matTooltip="Company Name" matTooltipPosition="above">
            {{ applicant?.agentDetails?.generalDetails?.company || "-" }}
          </span>
          <span class="d-block" matTooltip="Email" matTooltipPosition="above">
            {{ applicant?.agentDetails?.generalDetails?.email || "-" }}</span>
          <span class="d-block" matTooltip="Mobile Number" matTooltipPosition="above">
            {{ applicant?.agentDetails?.generalDetails?.mobile_extension ?
            applicant?.agentDetails?.generalDetails?.mobile_extension + ' ' +
            applicant?.agentDetails?.generalDetails?.mobile : applicant?.agentDetails?.generalDetails?.mobile || "-"
            }}</span>
        </td>
      </ng-container>

      <!-- Application Status Column -->
      <ng-container matColumnDef="applicationStatus">
        <th mat-header-cell *matHeaderCellDef>Application Status</th>
        <td mat-cell *matCellDef="let applicant">
          <ng-container *ngIf="
              applicant.currentStatus?.primaryStatus != 'Application Received';
              else showProcessed
            ">
            <span class="text-danger-emphasis d-block" matTooltip="Primary Status" matTooltipPosition="above">
              {{ applicant.currentStatus?.primaryStatus }}
            </span>
          </ng-container>
          <ng-template #showProcessed>
            <span class="text-success-emphasis d-block" matTooltip="Primary Status">
              {{ applicant.currentStatus?.primaryStatus }}
            </span>
          </ng-template>
          <span class="text-cell-light-color" matTooltip="Secondary Status" matTooltipPosition="above">
            {{ applicant.currentStatus?.secondaryStatus }}
          </span>
        </td>
      </ng-container>

      <!-- Action -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>View</th>
        <td mat-cell *matCellDef="let applicant">
          <button mat-icon-button color="primary" (click)="onViewApplicant(applicant)">
            <img src="./assets/images/view-icon-blue.svg" alt="View" />
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </ng-container>

  <ng-template #noResults>
    <!-- <p>No results found for this search: Kindly try another search with the keyword "{{ data.search }}" 😕 </p> -->
    <app-no-data-found></app-no-data-found>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="closeDialog()">Close</button>
</mat-dialog-actions>